import gql from "graphql-tag";

export default gql`
  query BuildingCollectionsAvailabilityQuery(
    $listingId: ID!
    $checkInDate: String
    $checkOutDate: String
    $prices: [Int!]
    $sleeps: Int
    $source: String
    $targetCurrency: String
  ) {
    buildingCollectionsAvailability(
      listingId: $listingId
      checkInDate: $checkInDate
      checkOutDate: $checkOutDate
      prices: $prices
      sleeps: $sleeps
      source: $source
      targetCurrency: $targetCurrency
    ) {
      collections {
        adaAccessibilityInfo {
          isHearingAccessible
          isMobilityAccessible
          mobilityFeatures
          hearingFeatures
        }
        amenities {
          name
          active
          label
        }
        available
        bathroomCount
        bedroomCount
        collectionName
        collectionType
        collectionId
        displayPrice
        displayPriceRaw
        displayPriceLabel
        longTermRental
        minimumStayLength
        photos {
          tag
          caption
          mediumSrc
          smallSrc
          xlargeSrc
          largeSrc
        }
        quote {
          invoice {
            adr
            contactToBookLts
            isBookingDisabled
            lineItems {
              key
              label
              value
              primary
            }
          }
          rateLabel
          totalLabel
          originalRateLabel
          remainingUnitsCount
        }
        sleepCount
        squareFootage
        viewCount
      }
      filters {
        availabilityFilter {
          selected {
            checkInDate
            checkOutDate
          }
        }
        guestCountFilter {
          options {
            min
            max
          }
          selected
        }
        pricingFilter {
          options {
            min
            max
          }
          selected {
            min
            max
          }
        }
      }
    }
  }
`;
